import React, { useState, useEffect } from "react";
import ResumenAlumno from "./subComponents/ResumenAlumno";
import CreditCardInputs from "../../c&m/facturacion/CreditCardInputs";
import { Formik, Form } from "formik";
import WarningModal from "../../components-modals/WarningModal";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { fechaSinGuiones } from "../../tools/ConversionFechas";
import { enviarPago } from "../api/Paso3.api";
import { BanknotesIcon, CreditCardIcon } from "@heroicons/react/24/outline"

const Cotizacion = ({ urlCursos, state, send, setLoading, pathname, IdEmp }) => {
  
  const [modal, setModal] = useState({
    ok:false,
    show:false,
    msg:"",
  })

  const initialValues = {
    /*
    IdBodega: "",
    Nit: "",
    NombreDoc: "",
    Direccion: "",
    tarjeta: "",
    efectivo: "",
    */
  };
//elemento?.Seleccionado && !elemento?.Cobrado
  const [total, setTotal] = useState(state.context.seleccionados.filter(elemento => elemento?.Pagar && !elemento?.Cobrado).reduce((anterior, actual) => anterior + actual.Valor, 0));
  //const [subtotal, setsubTotal] = useState(0);
  const [subtotal, setsubTotal] = useState(state.context.seleccionados.filter(elemento => elemento?.Pagar && !elemento?.Cobrado).reduce((anterior, actual) => anterior + actual.Valor, 0));
  const [tarjetaMonto, setTarjetaMonto] = useState()
  const [efectivoMonto, setEfectivoMonto] = useState()
  const [enableButton, setEnableButton] = useState(true)
  const [IdSolicitud, setIdSolicitud] = useState(state.context.solicitud)
  const [isEnabled, setIsEnabled] = useState(true)
  const [formasPago, setFormasPago] = useState(state.context.formaspago)


  const setNoCobrados = (array) => { // no lo estoy mandando bien, debo mandar todo, no solo los cargos
    //console.log('CURSOS1', array)
    //console.log('CURSOSSSSS:  ', array.Cursos)
    const cursos1 = array.Cursos.map(curso => {
      const cobrados = curso.Cargos.filter(checkPendiente)
      //const cobrados = curso.Cargos.filter(cargo => !cargo.Pagar) //!cargo.Pagar
      //console.log('COBRADOS::::::', cobrados)
      curso.Cargos = cobrados
      return curso
    })
    //console.log('cursos::', cursos1)
    return cursos1
  };

  function checkPendiente(cargo) { 
       if(cargo?.Seleccionado && cargo?.Pagar && !cargo?.Cobrado){
         return cargo;
       }
   /*
   if (cargo.hasOwnProperty("Cobrado")) {
    console.log('tiene la propiedad Cobrado')
    console.log(cargo)
       if(!cargo.Cobrado && cargo.Pagar){
         return cargo;
       }
   }*/
}

  const postPagar = async (values, errors, setLoading) => {
    setLoading(true)
    const fecha = new Date()
    const mesTransaccion = `${fecha.getMonth() + 1}`.padStart(2, '0')
    const diaTransaccion = `${fecha.getDate() + 1}`.padStart(2, '0')
    
    if (formasPago.Efectivo === false) {
      setTarjetaMonto(total)
    }
    
    const mes = (tarjetaMonto > 0 ? values.mmyy.split('/')[0] : 0)
    const year = (tarjetaMonto > 0 ? `20${values.mmyy.split('/')[1]}` : 0)

    const infoPago = {
      "Carnet": state.context.carnet,
      "number": (tarjetaMonto > 0 ? values.number : ''),
      "code": (tarjetaMonto > 0 ? values.code : 0),
      "nombres": (tarjetaMonto > 0 ? values.nombres : ''),
      "apellidos": (tarjetaMonto > 0 ? values.apellidos : ''),
      "direccion": (tarjetaMonto > 0 ? values.direccion : ''),
      "pais": (tarjetaMonto > 0 ? values.pais : ''),
      "email": (tarjetaMonto > 0 ? values.email : ''),
      "monto": tarjetaMonto,
      "mes": mes,
      "year": year,
      "IdSolicitud": parseInt(IdSolicitud),
      "Id": parseInt(IdSolicitud),
      "CanalPago": formasPago.CanalPagos,
      "HostName": "DEV07",
      "IpHost": "131.107.1.235",
      "IdEmp":  IdEmp,
      "OS": "Windows",
      "IdComercio": "",
      "FormasPago": {

        "Detalle": [
          {
            "TipoTrans": 1,
            "NoBoleta": "",
            "IdBanco": 0,
            "Valor": efectivoMonto,
            "Fecha": ""
          },
          {
            "TipoTrans": 8,
            "NoBoleta": "",
            "IdBanco": 0,
            "Valor": tarjetaMonto,
            "Fecha": (tarjetaMonto > 0 ? fechaSinGuiones(`${fecha.getFullYear()}-${mesTransaccion}-${diaTransaccion}`) : '')
          }
        ],
      },
      "Cursos": {Cursos:setNoCobrados(state.context.cursos)},
    }
    try {
    const respuestaPago = await enviarPago(urlCursos, infoPago, state.context.headers)
      //setLoading(false)
      if (respuestaPago.msg[0]["IdSolicitud"]) {
        setLoading(false)
        setPagoExitoso()
        send("PAGAR");
      } else { 
        setLoading(false)
        setModal({
          ok: false,
          show: true,
          msg: "No se ha realizado el pago de forma correcta",
        });
      }      
    } catch (error) {
      setLoading(false)
      console.log(error)
      setModal({
        ok: false,
        show: true,
        msg: error.response.data.msg.Mensaje,
      });
    }
  }

  const Pagar = async (e, values, errors) => {
    if(!isNegative(efectivoMonto) || !isNegative(tarjetaMonto) ) {
      console.log(isEnabled)
        e.preventDefault();
        setIsEnabled(false)
        if (Object.keys(errors).length > 0) {
          console.log(errors)
          setModal({
            ok: false,
            show: true,
            msg: "Se han encontrado datos faltantes o incorrectos",
          });
        } else {
          await postPagar(values, errors, setLoading)
        }
    } 
  };

  const cancelar = () => {
    send("CANCELAR");
  };

  const isNegative = (numero) => {
    if (Math.sign(numero) < 0) {
      return true;
    } else {
      return false;
    }
  }

  const handlesetEfectivoMonto = (value) => {
    const valor = parseInt(value)
    setEfectivoMonto(valor)
    setTarjetaMonto(total - valor)
    setsubTotal(efectivoMonto + tarjetaMonto)
  }

  const handlesetTarjetaMonto = (value) => {
    const valor = parseInt(value)
    setTarjetaMonto(valor)
    setEfectivoMonto(total - valor)
    setsubTotal(efectivoMonto + tarjetaMonto)
    setsubTotal(valor)
  }

  useEffect(() => {
    setIsEnabled(true)
    if (formasPago.Efectivo === false) {
      setTarjetaMonto(total)
    }
    function handlePress(event) {
      if (
        document.activeElement.name === "number" ||
        document.activeElement.name === "code" ||
        document.activeElement.type === "number"
      ) {
        if (!`${event.target.value}${event.key}`.match(/^[0-9]*$/)) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      }
    }
    window.addEventListener("keypress", handlePress);

    return () => {
      window.removeEventListener("keypress", handlePress);
    };
  }, []);

  const finalizar = () => {
    setModal({
      ok: true,
      show: true,
      msg: "Tus datos y cursos seleccionados han sido guardados",
      showOptions: true,
    })
  }

  const setPagoExitoso = () => {
    console.log('pago exitoso')
    setModal({
      ok: true,
      show: true,
      msg: "Pago realizado correctamente",
      showOptions: true,
    })
  }

  const Paso1 = () => {
    send("CANCELAR");
    send("CANCELAR");
  }

  const handleSubmit = (values, errors) => {
    isNegative(efectivoMonto) || isNegative(tarjetaMonto) ? console.log("no se puede " + IdEmp) : isEnabled && Pagar(values, errors)
  }

  return (
    <>
     <WarningModal
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >

        <div className="mt-5 sm:mt-6">
          {!modal.showOptions ?
            <button
              onClick={() => {
                if (modal.reload) {
                  window.location.reload();
                }
                setModal((curr) => ({
                  ...curr,
                  show: false,
                  reload: false,
                }));
              }}
              type="button"
              className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
            >
              Entendido
            </button>
            :
            <div className='flex flex-row justify-center'>
            <button
              onClick={() => { (pathname === '/campus/centro') ? Paso1() : send("CANCELAR_2") }}
              // onClick={() => window.location.reload()}
              className="inline justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
            >Aceptar</button>
            {/*
            <button
              onClick={() => setModal({ show: false })}
              className="inline justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
            >Cancelar</button>
            */}
          </div>
          }
        </div>

      </WarningModal>
    <Formik
      initialValues={initialValues}
      onSubmit={()=> {}}
    >
      {({ setFieldValue, values, touched, errors }) => {
        return (
          <Form>
            <div className={"w-full lg:w-1/4 mx-auto bg-primarioMira rounded-md p-1 elementFadeIn"}>
              <ResumenAlumno
                row={false}
                datosInscripcion={state.context.datosUsuario}
                carnet={state.context.carnet}
                />
              
              <div className="grid grid-rows-1 grid-flow-col w-full">

                {/*<p className="text-base text-center text-white">Forma de pago permitidas</p>*/}
                <div className="flex flex-col">
                  {formasPago.Efectivo &&
                    <>
                      <p className="rative blockel w-full mt-1 text-base text-center text-green-500">Efectivo</p>
                      <BanknotesIcon className="relative block h-16 w-16 text-green-500 mx-auto" />
                    </>}
                </div>
                <div className="flex flex-col">
                  {formasPago.TC &&
                    <>
                      <p className="relative block w-full mt-1 text-base text-center text-secundario">Tarjeta</p>
                      <CreditCardIcon className="relative block h-16 w-16 text-secundario mx-auto" />
                    </>}
                </div>
              </div>
              <p className="text-lg text-center text-grisMira">Ingresa los siguientes datos solicitados.</p>
              {formasPago.Efectivo &&
                <div className="grid grid-rows-1 grid-flow-col  w-full">
                  <div className="flex flex-col">
                    <label
                      htmlFor="efectivoMonto"
                      className="inline text-sm font-medium text-grisMira">
                      Monto de efectivo
                    </label>
                    <input
                      name="efectivoMonto"
                      type="number"
                      className="relative block w-full rounded-md border-gray-300  focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                      onChange={(e) => handlesetEfectivoMonto(e.target.value)}
                      value={efectivoMonto}>
                    </input>
                  </div>
                  <div className="flex flex-col">
                    <label
                      htmlFor="tarjetaMonto"
                      className="inline text-sm font-medium text-grisMira"
                      >
                      Monto de tarjeta
                    </label>
                    <input
                      name="tarjetaMonto"
                      type="number"
                      className="relative block w-full rounded-md border-gray-300  focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                      onChange={(e) => handlesetTarjetaMonto(e.target.value)}
                      value={tarjetaMonto}
                    ></input>
                  </div>
                </div>}
              <CreditCardInputs
                setModal={setModal}
                setFieldValue={setFieldValue}
                values={values}
                errors={errors}
                touched={touched} />
              <div>
                <div className="order-last col-span-full bg-primarioMira px-5 flex items-center justify-between border-t border-gray-200 mt-5 pt-5 text-gray-900">
                  <p className="text-base font-semibold text-grisMira">
                    Subtotal
                  </p>
                  <p className="text-base font-semibold text-white">
                    <span
                      className={`${Number(total) === Number(subtotal)
                        ? "bg-green-500/80"
                        : "bg-red-500/80"} px-2 py-1 rounded-full`}
                        >
                      {Intl.NumberFormat("es-GT", {
                        style: "currency",
                        currency: "GTQ",
                      }).format(subtotal | 0)}
                    </span>
                  </p>
                </div>
                <div className="order-last col-span-full bg-secundarioMira p-5 flex items-center justify-between border-t border-gray-200 mt-5 pt-5 text-gray-900">
                  <p className="text-base font-semibold text-grisMira">
                    Total
                  </p>

                  <p className="text-base font-semibold text-white">
                    {Intl.NumberFormat("es-GT", {
                      style: "currency",
                      currency: "GTQ",
                    }).format(total)}
                  </p>
                </div>
              </div>

              <div className={"flex flex-row justify-between pt-2 gap-2"}>{/*w-full md:w-1/2 lg:w-1/2 xl:w-1/2 2xl:w-1/4 mx-auto bg-primarioMira rounded-md p-1 elementFadeIn*/}
                {enableButton &&
                  <button
                  className="text-white p-2 rounded-md bg-azulBrillanteMira"
                  onClick={() => cancelar()}
                  >
                    Atrás
                  </button>}
                  {(pathname === '/campus/centro') ?
                  <button
                    className="text-white p-2 rounded-md bg-azulBrillanteMira"
                    onClick={() => finalizar()}
                    >
                    Guardar e inscribir más tarde
                  </button>
                  : null
                  }
                {enableButton &&
                  <button
                    type="button"
                    className="text-white p-2 rounded-md bg-azulBrillanteMira"
                    onClick={(e) => {setIsEnabled(true);Pagar(e, values, errors)}}
                    >
                    Aceptar
                  </button>}
              </div>
            </div>
          </Form >
        );
      }}
    </Formik >
        </>
  );
};

export default Cotizacion;
